export const environment = {
  production: true,
  API_URI: 'https://rrhh.api.qa.iturriapp.com/api/rest/',
  PUBLIC_URI: 'https://rrhh.api.qa.iturriapp.com/public/rest/',
  CDN_BASE: 'https://rrhh.api.qa.iturriapp.com/',
  API_ITURRIAPP: 'https://api.iturriapp.com/public/rest/',
  CDN_CLOUDINARY: '',
  PARAM: {
    ACTIVO: '1',
    INACTIVO: '0',
    SI: '1',
    NO: '0',
    TODOS: '-1',
    VACIO: ''
  },
  HTTP_RESPONSE: {
    SUCCESS: 1,
    WARNING: 2,
    ERROR: 3,
    INFO: 4,
    PERMISION_ERROR: 401,
    CODE_NOT_DEFINED: 601,
    MALFORMED_JSON: 701,
    ACCESS_DENIED: 403
  },
  SOLICITUD_ESTADO: {
    PENDIENTE : "1",
    APROBADO : "2",
    RECHAZADO : "0"
  },
  USUARIO_CARGO: {
    ADMINISTRADOR: "1",
    DOCTOR: "2",
    JEFE: "3",
    SISTEMAS: "4",
  },
  PERMISO: {
    ASISTENCIA_REPORTE_GENERAL: '001',
    ASISTENCIA_REPORTE_JEFE: '002',
    ASISTENCIA_CONSOLIDADO_HORAS: '003',

    SOLICITUD_VACACIONES: '004',
    SOLICITUD_MOVILIDAD: '005',
    SOLICITUD_CUPONES: '006',
    SOLICITUD_DESCANSO_MEDICO: '007',
    SOLICITUD_PERMISO: '027',

    GEST_TRAB_VALIDAR_FOTOCHECK: '008',
    GEST_TRAB_GESTION: '009',
    GEST_TRAB_CESADOS: '010',
    GEST_TRAB_IMPORTADOR: '011',
    GEST_TRAB_ASIGNAR_EMP: '026',

    DATA_TRAB_ACCESOS_PC: '012',
    DATA_TRAB_INVENTARIO: '013',
    DATA_TRAB_ACCESOS_GENERALES: '014',
    DATA_TRAB_REGISTRO_EQUIPOS: '015',
    DATA_TRAB_REGISTRO_TELEFONO: '016',
    DATA_TRAB_IMPORTADOR: '017',

    REPORTES: '018',
    GESTION_USUARIOS: '019',
    CAMPANAS_PHISHING: '020',
    CLIMA_LABORAL: '028',
    DESEMPENO: '029',
    PLANILLA: '030',

    REGISTRO_SEDES: '021',
    REGISTRO_AREAS: '022',
    REGISTRO_PUESTOS: '023',
    REGISTRO_CORREOS: '024',
    REGISTRO_EMPRESA: '025'
  }
};
